import axios from 'axios';
import React, { useEffect, useState } from 'react'

export default function SummaryUser() {
    const [data, setData] = useState();

    useEffect(() => {
        axios.get(`http://${process.env.REACT_APP_API_URL}/orders/summary-user`, {
            headers: {
                Bearer: localStorage.getItem('token')
            }
        }).then((response) => {
            if (response.status === 200) {
                setData(response.data);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error);
        });
    }
        , [])
    
        // console.log(data);
    return (
        // <div style={{display:"flex", justifyContent:"center" }} className='w-full'>
        <>
            {data && <div className='grid'>
                <div className='summary' >
                    <div className='text-center'>Orders Completed</div>
                    <div className='text-center'>{data.sumAmount}</div>
                </div>
            </div>}
            
        </>

    )
}
